package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.model.GmInventoryItem
import fr.manyverse.app.domain.repository.GmInventoryRepository
import fr.manyverse.app.domain.repository.ImageStorageRepository

class DeleteGmInventoryItemUseCase(
    private val gmInventoryRepository: GmInventoryRepository,
    private val imageStorageRepository: ImageStorageRepository
) {
    suspend operator fun invoke(item: GmInventoryItem): Result<Unit> {
        if (item.imageUrl != null) {
            imageStorageRepository.delete(ImageTarget.GmInventoryItem(item.tableId, item.id))
        }
        return gmInventoryRepository.deleteItem(item.id)
    }
}
